// extracted by mini-css-extract-plugin
export default {"Html":"Html--6tiG2","hasError":"hasError--gBBam"};